function normalizeComparableName(value) {
  return String(value || '').normalize('NFKC').trim().toLocaleLowerCase();
}

function baseNameKey(value) {
  const normalized = normalizeComparableName(value);
  const dot = normalized.lastIndexOf('.');
  return dot > 0 ? normalized.slice(0, dot).trim() : normalized;
}

function matchLocalFiles(pictures = [], localFileNames = []) {
  const expectedKeys = new Set(pictures.map(picture => (
    baseNameKey(picture.originalFileName || picture.fileName)
  )).filter(Boolean));
  const selected = localFileNames.filter(name => expectedKeys.has(baseNameKey(name)));
  const matchedKeys = new Set(selected.map(baseNameKey));
  const unmatchedPictureCount = [...expectedKeys].filter(key => !matchedKeys.has(key)).length;
  return { selected, unmatchedPictureCount };
}

function summarizeSourceFolders(pictures = []) {
  const counts = new Map();
  let unknownCount = 0;
  pictures.forEach(picture => {
    const folderName = String(picture?.sourceFolderName || '').trim();
    if (!folderName) {
      unknownCount += 1;
      return;
    }
    counts.set(folderName, (counts.get(folderName) || 0) + 1);
  });
  const folders = [...counts.entries()]
    .map(([name, count]) => ({ name, count }))
    .sort((left, right) => right.count - left.count || left.name.localeCompare(right.name));
  return {
    folders,
    recommended: folders[0] || null,
    knownCount: pictures.length - unknownCount,
    unknownCount,
    total: pictures.length,
  };
}

function isSameFolderName(left, right) {
  return normalizeComparableName(left) === normalizeComparableName(right);
}

export { baseNameKey, isSameFolderName, matchLocalFiles, normalizeComparableName, summarizeSourceFolders };
